import { faX } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Modal } from '@mui/material';
import './styles.scss';

interface IConfirmResetModal {
  open: boolean;
  handleClose: () => void;
  handleResetData: () => void;
  message: string;
  title: string;
  confirmButton: string;
  cancelButton?: string;
}

const ConfirmResetModal = ({
  open,
  handleClose,
  handleResetData,
  message,
  title,
  confirmButton,
  cancelButton,
}: IConfirmResetModal) => {
  const resetData = () => {
    handleClose();
    handleResetData();
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <div className="confirm-reset-modal-container">
        <div className="confirm-reset-modal-content">
          <div className="header">
            <h1>{title}</h1>

            <Button className="close-button" onClick={handleClose}>
              <FontAwesomeIcon icon={faX} />
            </Button>
          </div>

          <div className="subtitle">{message}</div>

          <div className="buttons">
            <Button className="cancel-button" onClick={handleClose}>
              {cancelButton || 'Cancel'}
            </Button>
            <Button className="restore-button" onClick={resetData}>
              {confirmButton}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmResetModal;
